// extracted by mini-css-extract-plugin
export default {"scrollBar":"ProductsShow_scrollBar__f62S+"};